import BookOutlineIcon from "./BookOutlineIcon";
import BuildingOutlineIcon from "./BuildingOutlineIcon";
import CandleOutlineIcon from "./CandleOutlineIcon";
import CheckIcon from "./CheckIcon";
import ChevronDownIcon from "./ChevronDownIcon";
import ChevronLeftIcon from "./ChevronLeftIcon";
import ChevronRightIcon from "./ChevronRightIcon";
import ClipboardListOutlineIcon from "./ClipboardListOutlineIcon";
import CopyFromIcon from "./CopyFromIcon";
import FilterIcon from "./FilterIcon";
import PlayButtonIcon from "./PlayButtonIcon";
import PlusSmIcon from "./PlusSmIcon";
import SearchIcon from "./SearchIcon";
import SelectorIcon from "./SelectorIcon";
import TrashOutlineIcon from "./TrashOutlineIcon";
import UserOutlineIcon from "./UserOutlineIcon";
import XIcon from "./XIcon";

export {
  BookOutlineIcon,
  BuildingOutlineIcon,
  CandleOutlineIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClipboardListOutlineIcon,
  CopyFromIcon,
  FilterIcon,
  PlayButtonIcon,
  PlusSmIcon,
  SearchIcon,
  SelectorIcon,
  TrashOutlineIcon,
  UserOutlineIcon,
  XIcon,
};
